var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInvoicePendingV1 = function SvgInvoicePendingV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Invoice-Pending"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.33,9.14c0,16.25,0,34.64,0,51A1.27,1.27,0,0,1,52,61.37H5.78a1.27,1.27,0,0,1-1.3-1.24c0-15.62,0-32.14,0-47.71V2.35A1.53,1.53,0,0,1,6,.85H51.76a1.53,1.53,0,0,1,1.56,1.49Z",
    style: {
      fill: "#edfdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.31,34.77a7.17,7.17,0,0,1,1.67.06,14.21,14.21,0,0,1,1.09,28.06,9.5,9.5,0,0,1-2.76.23.47.47,0,0,1-.16-.32,15.1,15.1,0,0,1,.05-2.69c.13-.28.39-.26.63-.27a10.91,10.91,0,0,0,1.63-21.59,7.69,7.69,0,0,0-1.66-.2c-.23,0-.46,0-.59-.25a14.44,14.44,0,0,1-.06-2.71A.45.45,0,0,1,45.31,34.77Z",
    style: {
      fill: "#ffc431"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.31,34.77v3.12l0,.06a11.32,11.32,0,0,1-1.65.25,10.88,10.88,0,0,0-1.88,21,13.47,13.47,0,0,0,3.08.62.77.77,0,0,1,.45.1l0,.06v3.12a13.1,13.1,0,0,1-4.39-.69l-.55-.14a16.18,16.18,0,0,1-3.69-2.09,14.2,14.2,0,0,1,6-25.2A10.3,10.3,0,0,1,45.31,34.77Z",
    style: {
      fill: "#ffc431"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,37.89a10.61,10.61,0,0,1,6,1.73,10.73,10.73,0,0,1,4.65,6.07,11.05,11.05,0,0,1-5.23,12.93A10.72,10.72,0,0,1,45.3,60v0a.9.9,0,0,1-.18-.63V51.59a1.19,1.19,0,0,1,.1-.56c.15-.25.41-.23.65-.26a1.37,1.37,0,0,0,1.37-1.52c0-1.49,0-3,0-4.46a1.45,1.45,0,0,0-1.58-1.65c-.16,0-.32,0-.43-.15a.84.84,0,0,1-.06-.14c-.09-1.54-.05-3.07,0-4.61a.44.44,0,0,1,.15-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,37.92v5.14a.29.29,0,0,0,0,.09.92.92,0,0,1-.28.31,1.6,1.6,0,0,0-.59,1.34v2.31c0,.73-.11.83-.87.84s-1.6,0-2.41,0a1.4,1.4,0,1,0,0,2.8c1.12.05,2.24,0,3.36,0a1.45,1.45,0,0,1,.77.1l.06.07v9a11,11,0,0,1-10.9-9.38,10.57,10.57,0,0,1,2.26-8.47A10.7,10.7,0,0,1,45.3,37.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.31,43.06a1.56,1.56,0,0,1,2.1,1.6v4.45c0,1.29-.54,1.82-1.85,1.83H45.3v0a.76.76,0,0,1-.18-.58q0-3.32,0-6.64a1,1,0,0,1,.19-.63Z",
    style: {
      fill: "#ffc431"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.31,43.08v7.85c-1.4,0-2.8,0-4.2,0a1.58,1.58,0,1,1,0-3.15c.87,0,1.75,0,2.62,0,.39,0,.53-.1.52-.5,0-.8,0-1.61,0-2.41A1.73,1.73,0,0,1,45.31,43.08Z",
    style: {
      fill: "#ffc431"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,11.55c0,.94.72,1.58,2,1.61A4.09,4.09,0,0,1,33,16.28a4,4,0,0,1-2.26,4.6c-.54.24-.83.45-.79,1.08a1,1,0,0,1-1.08,1.17,1.08,1.08,0,0,1-1.17-1.2A1,1,0,0,0,27,20.77,3.33,3.33,0,0,1,25.3,19a1,1,0,0,1,.41-1.54,1.07,1.07,0,0,1,1.61.45A1.78,1.78,0,0,0,29.21,19a1.94,1.94,0,0,0,1.7-1.85A1.82,1.82,0,0,0,29,15.45a4,4,0,0,1-3.92-2.3,3.91,3.91,0,0,1,1.74-5.32c.58-.28,1-.53,1-1.3a1.05,1.05,0,0,1,1.12-1.06A1,1,0,0,1,30,6.53a1.27,1.27,0,0,0,1,1.41,3.39,3.39,0,0,1,1.53,1.62A1.1,1.1,0,0,1,32,11.23c-.65.35-1.12.07-1.48-.54-.58-1-1.17-1.25-2.08-1A1.68,1.68,0,0,0,27,11.55Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.83,36.06H13.28a1.22,1.22,0,1,1,0-2.44H28.42a1.22,1.22,0,1,1,0,2.44Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,27.15H44.31a3.84,3.84,0,0,1,.68,0,1.18,1.18,0,0,1,1,1.25,1.16,1.16,0,0,1-1,1.16,3.08,3.08,0,0,1-.61,0H13.42a4.09,4.09,0,0,1-.61,0,1.18,1.18,0,0,1-1-1.25,1.16,1.16,0,0,1,1-1.16,3.08,3.08,0,0,1,.68,0Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73,41.94H13.11c-.85,0-1.3-.42-1.3-1.21s.44-1.22,1.28-1.23H28.4c.85,0,1.3.43,1.3,1.22a1.12,1.12,0,0,1-1.28,1.22Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73,47.81H13.11c-.85,0-1.3-.42-1.3-1.21a1.12,1.12,0,0,1,1.28-1.23H28.4c.85,0,1.3.43,1.3,1.21a1.12,1.12,0,0,1-1.28,1.23Z",
    style: {
      fill: "#5e80e6"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoicePendingV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Invoice_Pending_v1.4075b50f.svg";
export { ForwardRef as ReactComponent };